<script>
import AdminHeader from "@/components/Admin/header.vue"
import AdminSidebar from "@/components/Admin/sidebar.vue"
import PaginationTable from "@/components/Admin/pagination-table.vue"
import HeadBlock from "@/components/Admin/head-block.vue"
import {mapState} from "vuex";

export default {
    components: {
        AdminHeader, AdminSidebar, PaginationTable, HeadBlock
    },
    data() {
        return {
            storeKeys: {
                products: 'product',
                orders: 'order',
                pages: 'page',
                users: 'user'
            },
            perPage: 10,
            currentPage: 1,
            headers: {
                pages: ['Страницы', 'Добавить новую'],
                products: ['Товары', 'Добавить новый'],
                orders: ['Заказы', 'Добавить новый'],
                users: ['Пользователи', 'Добавить нового']
            },
            columns: {
                pages: [2, 4, 0, 0, 3, 2, 2],
                products: [2, 4, 0, 0, 2, 0, 0, 2, 0, 2, 0, 0, 2],
                orders: [0, 2, 3, 3, 2, 2, 2, 3, 0, 0, 0, 0, 0, 0, 0],
                users: [2, 4, 3, 3]
            },
            mainColumn: {
                pages: "Заголовок",
                products: "Код",
                orders: "Номер",
                users: "ID",
            },
            searchText: '',
            isLoading: false
        }
    },
    computed: {
        currentTab() {
            let fullPath = this.$route.path.split('/')
            let tab = fullPath[fullPath.length-1]
            return tab
        },
        currentFetch() {
            let tab = this.currentTab
            tab = tab.charAt(0).toUpperCase() + tab.slice(1)
            return tab
        },
        ...mapState({
            // если fetch был неудачным, есть вероятность бага, текст с Ошибкой идет в обработку и выдает 34-символьную строку, она дробится на страницы
            dataStore(state) {
                try {
                    return state[this.storeKeys[this.currentTab]][this.currentTab];
                }
                catch (e) {
                    return []
                } // Используем динамический ключ
            },
        }),
        paginatedData() {
            const startIndex = (this.currentPage - 1) * this.perPage;
            if (typeof this.filteredItems === 'object') {
                return this.filteredItems.slice(startIndex, startIndex + this.perPage);
            }
            return []
        },
        totalItems() {
            if (this.filteredItems) return this.filteredItems.length
            return 0
        },
        filteredItems() {
            if (!this.searchText) {
                return this.dataStore; // Если строка пустая, возвращаем весь массив
            }

            // Фильтруем объекты по всем свойствам
            return this.dataStore.filter(item => {
                return Object.values(item).some(value =>
                    String(value).toLowerCase().includes(this.searchText.toLowerCase())
                );
            });
        }
    },
    methods: {
        setCurrentPage(newPage) {
            this.currentPage = newPage;
        },
        setLoading() {
            this.isLoading = true
            setTimeout(() => this.unsetLoading(), 400)
        },
        unsetLoading() {
            this.isLoading = false
        }
    },
    mounted() {
        this.$store.dispatch(`product/fetchProductsAdmin`);
        this.$store.dispatch(`user/fetchUsers`);
        this.$store.dispatch(`page/fetchPages`);
        this.$store.dispatch(`order/fetchOrders`);
    },
}
</script>

<template>
    <admin-header></admin-header>
    <div class="page not-padding">
        <admin-sidebar :active-route='this.$route.name'></admin-sidebar>
        <div class="admin-page admin-container-padding">
            <div class="head-row">
                <head-block :headerText="this.headers[this.currentTab][0]"
                            :is-add-new="true"
                            :addNewText="this.headers[this.currentTab][1]"
                >
                </head-block>
                <div class="search-block">
                    <div class="loading-icn">
                        <svg :display="this.isLoading ? 'block' : 'none' " width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3C16.97 3 21 7.03 21 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="input-elem">
                        <input type="text" v-model="searchText" placeholder="Поиск" @input=this.setLoading>
                    </div>
                </div>
            </div>
            <pagination-table
                :tableName="'dataStore'"
                :data="this.paginatedData"
                :columns-width="this.columns[this.currentTab]"
                :items-per-page="this.perPage"
                :page="this.currentPage"
                :total-items="this.totalItems"
                :main-column="this.mainColumn[this.currentTab]"
                :table-header="this.headers[this.currentTab][0]"
                :current-tab="currentTab"
                @update:page="setCurrentPage"
            ></pagination-table>
        </div>
    </div>
</template>

<style scoped lang="scss">
.head-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2.75%;
}

.search-block {
    display: flex;
    align-items: center;
    gap: 5%;
}
</style>
